import fetchServer from "../fetchServer";

export default async function getLoans({ page = 1, limit = 10 }) {
  let result = { return: 0, msg: "Something went wrong logging user!" };

  await fetchServer({
    method: "GET",
    url: `/loans?page=${page}&limit=${limit}`,
  })
    .then((res) => {
      console.log({ res });
      if (res?.status === 200) {
        result = { return: 1, msg: "Welcome", data: res.data };
      } else {
        result["msg"] = res?.data?.error || result["msg"];
        result["data"] = res?.data;
      }
    })
    .catch((err) => {
      console.log(err);
      result["msg"] = err.message;
      console.log("Network Error!");
    });

  return result;
}
